export function transformToUser(data) {
    const user = Object.assign({}, data);
    if (typeof data.birthday !== 'undefined') {
        user.birthday = data.birthday ? new Date(data.birthday) : null;
    }
    return user;
}
